<main>
  <div class="ks-card">
    <div class="ks-card-body">
      <h3>Recent Transactions</h3>
      <kt-table
        [columns]="columns"
        [loadItemsAction]="loadTransactionsAction"
        [resetItemsAction]="resetTransactionsStateAction"
        [itemsSelector]="transactionsSelector"
        [itemsFilterSelector]="transactionsFilterSelector"
        [loadingSelector]="transactionsLoadingSelector"
        [defaultSortActive]="'paymentCode'"
      ></kt-table>
    </div>
  </div>
</main>

<ng-template #contact let-item>
  <div style="display: block">
    <div class="ks-text-1lns ks-font-size-md ks-font-weight-medium">
      {{ getContactName(item.customer_id) }}
    </div>
    <div class="ks-font-size-md ks-font-weight-medium">{{ getContactID(item.customer_id) }}</div>
  </div>
</ng-template>

<ng-template #paymentCode let-item>
  <div class="ks-text-1lns">{{ item.payment_code }}</div>
</ng-template>

<ng-template #dateAndTime let-item>
  <div>
    <a class="ks-font-size-md ks-font-weight-medium">{{
      item.transaction_date | date : 'dd MMM yyyy'
    }}</a>
    <div class="ks-font-size-sm ks-text-neutral ks-font-weight-medium" style="text-align: center">
      {{ item.transaction_date | date : 'hh:mm a' }}
    </div>
  </div>
</ng-template>

<ng-template #statusRef let-item>
  <div
    *ngIf="item.void_status !== 'Voided'"
    style="min-width: 140px"
    class="ks-badge-md ks-badge-light-{{ getTransactionStatusColor(item.status) }}"
  >
    {{ item.status | enumFormat : '_' }}
  </div>
  <div
    *ngIf="item.void_status === 'Voided'"
    style="min-width: 140px"
    class="ks-badge-md ks-badge-light-neutral"
  >
    {{ item.void_status | enumFormat : '_' }}
  </div>
</ng-template>

<ng-template #paymentCodeFilter let-control>
  <kt-input [type]="'text'" [label]="'Payment Code'" [control]="control"></kt-input>
</ng-template>
<ng-template #contactFilter let-control>
  <kt-autocomplete
    [control]="control"
    [optionsType]="'LIST'"
    [label]="'Contact'"
    [placeholder]="'Select Contact'"
    [options]="contactOptions"
    [optionType]="'OBJECT'"
    [objectOptionReq]="{
      idKey: 'contactUUID',
      searchKey: 'first_name',
      labelFormatter: formatContact,
      valueFormatter: formatContact
    }"
  ></kt-autocomplete>
</ng-template>

<ng-template #dateTimeFilter let-control>
  <kt-date-input
    [type]="'date'"
    [format]="'yyyy-MM-dd'"
    [label]="'Date Time'"
    [control]="control"
  ></kt-date-input>
</ng-template>

<ng-template #amountFilter let-control>
  <kt-input [type]="'number'" [label]="'Amount'" [control]="control"></kt-input>
</ng-template>

<ng-template #statusFilter let-control>
  <kt-autocomplete
    [label]="'Status'"
    [control]="control"
    [optionsType]="'LIST'"
    [options]="statusFilterOptions"
    [optionType]="'PRIMITIVE'"
  ></kt-autocomplete>
</ng-template>

<ng-template #actionsRef let-item>
  <button
    type="button"
    ktTooltip="View transaction details"
    class="ks-btn-sm ks-btn-icon-round ks-btn-flat-neutral ks-mr-2"
    (click)="onViewDetails(item)"
  >
    <span inlineSVG="assets/icons/Eye.svg"></span>
  </button>

  <button
    type="button"
    [disabled]="item.status !== 'Completed' || item.void_status === 'Voided'"
    ktTooltip="Void transaction"
    class="ks-btn-sm ks-btn-icon-round ks-btn-flat-danger ks-mr-2"
    (click)="voidTransaction(item)"
  >
    <span inlineSVG="assets/icons/Void.svg"></span>
  </button>
</ng-template>
